<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<!-- 替换为地图下拉筛选 -->
						<el-form-item :label="$t('device.device_map')" prop="map_id">
							<el-select v-model="formInline.map_id" style="width: 200px">
								<el-option label="全部" value=""></el-option>
								<el-option 
									v-for="item in mapData" 
									:key="item.id" 
									:label="item.name" 
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button @click="searchCont" type="primary">{{ $t('device.inquire') }}</el-button>
							<el-button @click="resetBtn" type="primary">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
					<div>
						<el-button @click="addUser" type="primary">
							{{ $t('device.add') }}
						</el-button>
					</div>
				</div>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="组织" prop="client_name" width="120"></el-table-column>
				<el-table-column label="地图" prop="map_name" width="120"></el-table-column>
				<el-table-column label="Mac地址" prop="mac" width="120"></el-table-column>
				<el-table-column label="名称" prop="name" width="80"></el-table-column>
				<el-table-column label="类型" prop="type" width="70">
					<template #default="scope">{{ getTypeName(scope.row.type)  }}</template>
				</el-table-column>
			<el-table-column label="设备状态" prop="online" width="100">
				<template #default="scope">
					<el-tag :type="scope.row.online == 1 ? 'success' : (scope.row.online == 2 ? 'info' : 'danger')" size="small">
						{{ scope.row.online == 1 ? '在线' : (scope.row.online == 2 ? '离线' : '停用') }}
					</el-tag>
				</template>
			</el-table-column>
				<el-table-column label="RSSI" prop="rssi" width="100"></el-table-column>
				<el-table-column label="路径损耗因子" prop="n" width="120"></el-table-column>
				<el-table-column label="X坐标" prop="x" width="120"></el-table-column>
				<el-table-column label="Y坐标" prop="y" width="120"></el-table-column>
				<el-table-column label="Z坐标" prop="z" width="120"></el-table-column>
				<el-table-column label="更新时间" prop="update_at" width="180"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="150">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small">编辑</el-button>
						<el-button @click="handleDelete(scope.row)" type="primary" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑" top="30vh" v-model="addPop" width="50%">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<div style="display: flex; gap: 20px;">
						<el-form-item label="组织" label-width="120px" prop="client_id">
							<el-cascader :options="clientOpts" placeholder="组织"
								v-model="addForm.client_id"></el-cascader>
						</el-form-item>
					</div>
					<div style="display: flex; gap: 20px;">
						<!-- 新增地图下拉选择 -->
						<el-form-item label="地图" label-width="120px" prop="map_id">
							<el-select 
								v-model="addForm.map_id" 
								placeholder="请选择地图" 
								style="width:100%"
							>
								<el-option 
									v-for="item in mapData" 
									:key="item.id" 
									:label="item.name" 
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
					</div>
					<el-form-item label="Mac地址" label-width="120px" prop="mac">
						<el-input type="text" v-model="addForm.mac" placeholder="参考格式:209BA5CC03EF"></el-input>
					</el-form-item>
					<el-form-item label="名称" label-width="120px" prop="name">
						<el-input type="text" v-model="addForm.name" placeholder=""></el-input>
					</el-form-item>

					<!-- 移除重复的名称表单项 -->
				<el-form-item label="类型" label-width="120px" prop="type">
					<el-select v-model="addForm.type" placeholder="请选择类型" style="width:100%">
						<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备状态" label-width="120px" prop="online">
					<el-select v-model="addForm.online" placeholder="请选择状态" style="width:100%">
						<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
					<el-form-item label="RSSI" label-width="120px" prop="rssi">
						<el-input type="text" v-model="addForm.rssi" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="路径损耗因子" label-width="120px" prop="n">
						<el-input type="text" v-model="addForm.n" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="X坐标" label-width="120px" prop="x">
						<el-input type="text" v-model="addForm.x" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="Y坐标" label-width="120px" prop="y">
						<el-input type="text" v-model="addForm.y" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="Z坐标" label-width="120px" prop="z">
						<el-input type="text" v-model="addForm.z" placeholder=""></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import message from "../../model/beacon";
	import deviceMap from "../../model/deviceMap";
	import client from "../../model/client";
	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				formInline: {
					map_id: "", // 新增地图筛选字段
					page: 1,
					size: 50
				},
				resetform: {
					map_id: "", // 重置表单对应字段
				},
				listCount: 0,
				appData: [],
				addPop: false,
			addForm: {
				client_id: "",
				mac: "",
				name: "",
				type: 1,
				online: 1,
				x: "",
				y: "",
				z: "",
				rssi: "",
				n: "",
				map_id: "", // 新增地图字段
			},
				clientListOpts: [],
				clientOpts: [],
				roleOpts: [],
				mapData: [], // 地图列表数据（已存在，无需新增）
			typeOptions: [{
					value: 1,
					label: "主基站"
				},
				{
					value: 2,
					label: "从基站"
				},
				{
					value: 3,
					label: "信标"
				},
				{
					value: 4,
					label: "不参与定位"
				}
			],
			statusOptions: [{
					value: 1,
					label: "在线"
				},
				{
					value: 2,
					label: "离线"
				},
				{
					value: 3,
					label: "停用"
				}
			],
				rules: {
					mac: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					name: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					type: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					map_id: [{ // 新增地图字段校验
						required: true,
						message: '请选择地图',
						trigger: "blur"
					}],
					client_id: [{ // 补充组织字段校验（之前遗漏）
						required: true,
						message: '请选择组织',
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			// 先加载地图数据，再加载设备数据（确保下拉选项可用）
			await this.loadMapData();
			await this.loadData();
			this.loadClient();
		},
		methods: {
			truncateText(text, limit) {
				return text?.length > limit ? `${text.substr(0,  limit)}...` : text || '-';
			},
			getTypeName(type) {
				const target = this.typeOptions.find(item => item.value === type);
				return target?.label || '未知';
			},
			resetFun() {
				// 重置地图筛选字段
				this.formInline.map_id = '';
				this.loadData();
			},
			// 搜索方法（原 seachFun 改名，与模板中 @click 对应）
			searchCont() {
				this.formInline.page = 1; // 搜索时重置页码到第一页
				this.loadData();
			},
			// 重置按钮方法（补充实现）
			resetBtn() {
				this.$refs.searchform.resetFields();
				this.formInline.page = 1;
				this.loadData();
			},
			async loadData() {
				// 传递 map_id 筛选条件到接口
				const ret = await message.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async loadMapData() {
				const ret = await deviceMap.list(this.formInline)
				if (ret.code === 200) {
					this.mapData = ret.data.list; // 地图数据：id 对应 map_id，name 对应地图名称
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						// 确保 map_id 字段传递到保存接口
						const ret = await message.save(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			addUser() {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = {
						client_id: "",
						mac: "",
						name: "",
						type: 1,
						online: 1,
						x: "",
						y: "",
						map_id: "", // 重置地图字段
						rssi: "",
						n: "",
					}
				})
			},
			handleEdit(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					let rowData = JSON.parse(JSON.stringify(row))
				this.addForm.client_id = rowData.client_id
				this.addForm.mac = rowData.mac
				this.addForm.name = rowData.name
				this.addForm.id = rowData.id
				this.addForm.type = rowData.type
				this.addForm.online = rowData.online
				this.addForm.x = rowData.x
				this.addForm.y = rowData.y
				this.addForm.z = rowData.z
				this.addForm.rssi = rowData.rssi
				this.addForm.n = rowData.n
				this.addForm.map_id = rowData.map_id // 编辑时回显地图字段
				})
			},
			async handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.delete({
							id: row.id

							})
							if (ret.code === 200) {

							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					ret.data.forEach(i => {
						let options = {
							value: i.id,
							label: i.name,
							children: []
						};
						this.clientListOpts.push({ //list
							value: i.id,
							label: i.name
						});

						if (i.children.length > 0) {
							this.clientOpts.push({
								value: i.id,
								label: i.name
							});
							i.children.forEach(v => {
								let opts = {
									value: v.id,
									label: v.name
								};
								this.clientListOpts.push({ //list
									value: v.id,
									label: v.name
								});

								if (v.children.length > 0) {
									options.children.push({
										value: v.id,
										label: v.name
									});
									opts.children = [];
									v.children.forEach(item => {
										let children = {
											value: item.id,
											label: item.name,
										};
										this.clientListOpts.push({ //list
											value: item.id,
											label: item.name
										});

										if (item.children.length > 0) {
											children.children = [];
											item.children.forEach(val => {
												children.children.push({
													value: val.id,
													label: val.name
												});
												this.clientListOpts.push({ //list
													value: val.id,
													label: val.name
												});
											})
										}
										opts.children.push(children);
									});
								}
								options.children.push(opts);
							});
						}
						this.clientOpts.push(options);
					});
				}
				console.log(JSON.stringify(this.clientOpts));
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
		justify-content: space-between; /* 调整按钮布局 */
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}
</style>
